import { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';
import { AxiosError } from 'axios';
import { getEmail as token2email } from '../../services/TokenService';
import { SCP_EMAIL, SendEmailErrorLog } from '../../services/EmailDal';

// Note the LoginPage.tsx has it's own error handling
export default function RouteErrorBoundary() {
    const error = useRouteError() as any;
    useEffect(() => {
        (async () => {
            await handleError(error);
        })();
    }, []);

    return (
        <div>
            <h1>{`oops... an error occured. Please contact ${SCP_EMAIL}`}</h1>
        </div>
    );
}

async function handleError(error: any) {
    try {
        const token = window.sessionStorage.getItem('sdatxtoken') ?? '';
        let email = '';
        try {
            email = await token2email(token);
        } catch (err) {
            console.log('can not get email from token setting to empty string start\n');
            console.log(err);
            console.log('can not get email from token setting to empty string end\n');
        }

        const exception = {
            email: email ?? '',
            message: '',
        };

        if (error instanceof AxiosError) {
            // backend errors
            const err = error as AxiosError;
            exception.message = `${err.response?.request.responseURL} ${err.response?.data} ${err.stack}`;
            console.log(error);
        } else if (error instanceof Error) {
            // front end errors
            // This needs to be last in the if statement chain
            const err = error as Error;
            exception.message = `${err.stack}`;
            console.log(error);
        } else {
            // other issue (like a server issue)
            console.log('An error outside of the application occured start\n');
            exception.message = error.toString();
            console.log(error);
            console.log('An error outside of the application occured end\n');
        }

        const logInConsole: boolean = import.meta.env.VITE_LOG_ERROR_IN_CONSOLE === '1';
        if (!logInConsole) {
            const entity = {
                too: import.meta.env.VITE_ERROR_EMAIL,
                from: null,
                bcc: null,
                subject: null,
                body: JSON.stringify(exception),
            };
            await SendEmailErrorLog(entity);
        } else {
            console.log(exception);
        }
    } catch (err) {
        console.log('error occured in global handler start\n');
        console.log(err);
        console.log('error occured in global handler end\n');
    }
}
